import { render, staticRenderFns } from "./DashboardMenuComponent.vue?vue&type=template&id=148bc708"
import script from "./DashboardMenuComponent.vue?vue&type=script&lang=js"
export * from "./DashboardMenuComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports